//Drag Question is a variant of H5P's DragQuestion.
//This interactive allows the user to drag labels into one of two.
//Also referred to as Drag and Drop: Sort Concept.
import Container from './container'
export default Container
